import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, input, ViewEncapsulation } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lay-panel-block',
  templateUrl: './panel-block.component.html',
  styleUrls: ['./panel-block.component.sass'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class PanelBlockComponent {
  readonly styleClass = input('');
  readonly size = input<'small' | 'default' | 'large' | 'fluid'>('default');
  readonly isBottomFixed = input(undefined);
  transparent = input(false, { transform: booleanAttribute });

  @HostBinding('class') get sizeClass():string {
    return `panel-block is-${this.size()} ${this.styleClass()} ${this.transparent() ? 'is-transparent-background is-borderless' : ''}`;
  }
}

/**
 * Used in Settings Legrand, Settings Lux
 */
